/*!
 * Copyright © 2018-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { TabsModule } from '../core/components';
import { ExternalModule } from '../external/external.module';
import { SharedModule } from '../shared';
import {
  DeviceHealthCheckComponent,
  DeviceHealthCheckContactSupportComponent,
  DeviceHealthCheckHistoryComponent,
  DeviceHealthCheckPingAndResetComponent,
  DeviceHealthCheckPingOnlyComponent
} from './components';
import { DeviceHealthCheckContainerComponent } from './containers';
import { DeviceHealthCheckIconModule } from './device-health-check-icon.module';
import { DeviceHealthCheckLiveChatService } from './services';

@NgModule({
  declarations: [
    DeviceHealthCheckComponent,
    DeviceHealthCheckContainerComponent,
    DeviceHealthCheckPingOnlyComponent,
    DeviceHealthCheckContactSupportComponent,
    DeviceHealthCheckPingAndResetComponent,
    DeviceHealthCheckHistoryComponent
  ],
  providers: [DeviceHealthCheckLiveChatService],
  imports: [
    CommonModule,
    SharedModule,
    MatStepperModule,
    MatIconModule,
    MatLegacyButtonModule,
    MatLegacyProgressSpinnerModule,
    ExternalModule,
    DeviceHealthCheckIconModule,
    TabsModule
  ],
  exports: [DeviceHealthCheckContainerComponent]
})
export class DeviceHealthCheckModule {}
